import { Map, Set } from 'immutable';

export function createTeam(team) {
  return new Map({
    id: team.id,
    locationId: team.location_id,
    name: team.name,
    colour: team.colour,
  });
}

export function set(teams) {
  return new Set(teams.map(team => createTeam(team)));
}

export function add(state, team) {
  return state.add(createTeam(team));
}

export function remove(state, id) {
  return state.filterNot(team => team.get('id') === id);
}

export function clear(state) {
  return state.clear();
}



// WEBPACK FOOTER //
// ./src/store/teams/lib.js